module.exports = __webpack_public_path__ + "img/话题.b604447c.png";